export default {
  viewBox: "0 0 24 24",
  html: "<path fill=\"#161B20\" fill-rule=\"evenodd\" d=\"M7.5 5.6 10 7 8.6 4.5 10 2 7.5 3.4 5 2l1.4 2.5L5 7zM7 14c-1.7 0-3 1.3-3 3 0 1.3-1.2 2-2 2 .9 1.2 2.5 2 4 2 2.2 0 4-1.8 4-4 0-1.7-1.3-3-3-3m13.7-9.4-1.3-1.3c-.4-.4-1-.4-1.4 0l-9 9 2.8 2.8 9-9c.3-.4.3-1.1-.1-1.5M17 14l2.5 1.4L22 14l-1.4 2.5L22 19l-2.5-1.4L17 19l1.4-2.5z\" clip-rule=\"evenodd\"/>"
};